<template>
  <ui-table :columns="columns" :rows="rows" :row-key="(row) => row.key" :row-class="rowClass" :end-label="$t('actions')" @open="(row) => $emit('open', row)">
    <template #cell-name="{ row }">
      <div class="ui-who">
        <ui-avatar :text="initialsOf(row.name)" :tone="row.kind.startsWith('restor') ? 'accent' : 'blue'" />
        <div :title="restaurantLabel(row.name)">
          <b>{{ restaurantLabel(row.name) }}</b>
          <small>#{{ row.restaurantId }} · {{ typeLabel(row.kind) }}</small>
        </div>
      </div>
    </template>

    <template #cell-status="{ row }">
      <ui-chip :tone="pendingTone(row.group)" dot>{{ pendingText(row) }}</ui-chip>
    </template>

    <template #cell-price="{ row }">
      <template v-if="priceParts(row).amount || priceParts(row).label">
        <b class="ui-num">{{ priceParts(row).amount || "—" }}</b>
        <small v-if="priceParts(row).label">{{ priceParts(row).label }}</small>
      </template>
      <span v-else class="ui-muted">—</span>
    </template>

    <template #cell-valid_from="{ row }">
      <span v-if="row.validFrom" class="ui-num">{{ localeDate(row.validFrom) }}</span>
      <span v-else class="ui-muted">—</span>
    </template>

    <template #cell-contract="{ row }">
      <template v-if="row.contractNumber">
        <b class="nw">{{ row.contractNumber }}</b>
        <small class="ui-num">{{ row.contractTo ? `${$t("until")} ${localeDate(row.contractTo)}` : $t("contract_status_no_deadline") }}</small>
      </template>
      <span v-else class="ui-muted">—</span>
    </template>

    <template #end="{ row }">
      <ui-button size="sm" @click.stop="$emit('open', row)">{{ $t("open") }}</ui-button>
    </template>

    <template #card="{ row }">
      <ui-item :tone="cardTone(row)" @click="$emit('open', row)">
        <span class="ui-who">
          <ui-avatar :text="initialsOf(row.name)" :tone="row.kind.startsWith('restor') ? 'accent' : 'blue'" />
          <span>
            <b>{{ restaurantLabel(row.name) }}</b>
            <small>#{{ row.restaurantId }} · {{ typeLabel(row.kind) }}</small>
          </span>
        </span>
        <span class="ui-item__tags">
          <ui-chip :tone="pendingTone(row.group)" dot>{{ pendingText(row) }}</ui-chip>
        </span>
        <span v-if="priceParts(row).amount || row.contractNumber" class="ui-item__line">
          <span v-if="priceParts(row).amount">
            {{ $t("price") }} <b class="ui-num">{{ priceParts(row).amount }}</b><template v-if="priceParts(row).label"> · {{ priceParts(row).label }}</template>
          </span>
          <span v-if="row.validFrom" class="ui-num">{{ $t("price_valid_from") }}: {{ localeDate(row.validFrom) }}</span>
          <span v-if="row.contractNumber">{{ $t("contract_number") }} <b>{{ row.contractNumber }}</b></span>
        </span>
      </ui-item>
    </template>
  </ui-table>
</template>

<script>
import hasContractLabels from "../hasContractLabels";

const CARD_TONES = { missing: "bad", contract_expired: "bad", no_amount: "warn", contract_expiring: "warn", unverified: "blue", ok: "muted" };

/**
 * Radni spisak cjenovnika (UiTable): restorani kojima nedostaje cijena, nema iznosa ili nije potvrđena, i ugovori na izmaku.
 * Red i dugme "Otvori" otvaraju ugovore kad je problem ugovor, a usluge i cijene kad je problem cjenovnik (kao na staroj stranici).
 */
export default {
  name: "PendingList",
  mixins: [hasContractLabels],
  props: {
    rows: { type: Array, required: true },
  },
  computed: {
    columns() {
      return [
        { key: "name", label: this.$t("restaurant") },
        { key: "status", label: this.$t("status") },
        { key: "price", label: this.$t("price") },
        { key: "valid_from", label: this.$t("price_valid_from"), hide: "sm", nowrap: true },
        { key: "contract", label: this.$t("contract_number"), hide: "md" },
      ];
    },
  },
  methods: {
    rowClass(row) {
      return { "is-off": row.group === "ok" };
    },
    cardTone(row) {
      return CARD_TONES[row.group] || "";
    },
  },
};
</script>
